/*
    
*/
'use strict';
angular.module("importTipsModule", [])
    .controller("importTipsCtrl", ["$scope",'$modalInstance','importResult',function($scope,$modalInstance,importResult) {
        initStatus();
        /**
         * [initStatus description]初始化参数
         */
        function initStatus() {

            $scope.status = {
                successNum :importResult.slice(-1)[0].SUCESSROW,
                loseNum:importResult.slice(-1)[0].LOSEROW
            };
            $scope.data = {
                lostRow : importResult.slice(0,-1)
            };
        }

        //取消
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);